import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Baby, KeyRound, ShieldCheck, Sparkles } from 'lucide-react';
import { useAuth } from '../auth';
import { ApiClientError } from '../api';
import { Logo } from '../components/Logo';
import { useToast } from '../components/Toast';

export function SetupPage() {
  const { setup } = useAuth();
  const { show } = useToast();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [form, setForm] = useState({
    setupSecret: '',
    familyName: 'Gia đình mình',
    timezone: 'Asia/Ho_Chi_Minh',
    monthlyBudgetVnd: 1_000_000,
    maxRewardPriceVnd: 500_000,
    parentName: '',
    email: '',
    password: '',
    childNickname: '',
    birthYear: new Date().getFullYear() - 8
  });

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    try {
      await setup({ ...form, birthYear: form.birthYear || null });
      show('Kidee đã được thiết lập. Bây giờ cùng khám phá sở thích của con nhé!', 'success');
      navigate('/survey', { replace: true });
    } catch (error) {
      show(error instanceof ApiClientError ? error.message : 'Không thể thiết lập ứng dụng.', 'error');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-hero">
        <Logo />
        <div className="mascot" aria-hidden="true">🦕⭐</div>
        <h1>Bắt đầu hành trình nhỏ, tạo thói quen lớn</h1>
        <p>Thiết lập một lần để gia đình ghi nhận nỗ lực, tích điểm và chọn quà phù hợp cho con.</p>
      </div>
      <form className="auth-card setup-form" onSubmit={submit}>
        <div className="form-section-title"><KeyRound size={20} /><span>Bảo vệ thiết lập</span></div>
        <label>
          Mã thiết lập từ máy chủ
          <input
            type="password"
            required
            autoComplete="one-time-code"
            value={form.setupSecret}
            onChange={(event) => setForm({ ...form, setupSecret: event.target.value })}
            placeholder="SETUP_SECRET"
          />
          <small>Mã này nằm trong file `.env` trên máy chủ, không phải mật khẩu đăng nhập.</small>
        </label>

        <div className="form-section-title"><ShieldCheck size={20} /><span>Gia đình & phụ huynh</span></div>
        <label>
          Tên gia đình
          <input required value={form.familyName} onChange={(event) => setForm({ ...form, familyName: event.target.value })} />
        </label>
        <div className="form-grid">
          <label>
            Tên phụ huynh
            <input required autoComplete="name" value={form.parentName} onChange={(event) => setForm({ ...form, parentName: event.target.value })} />
          </label>
          <label>
            Email
            <input required type="email" autoComplete="email" value={form.email} onChange={(event) => setForm({ ...form, email: event.target.value })} />
          </label>
        </div>
        <label>
          Mật khẩu
          <input required minLength={10} type="password" autoComplete="new-password" value={form.password} onChange={(event) => setForm({ ...form, password: event.target.value })} />
          <small>Tối thiểu 10 ký tự.</small>
        </label>

        <div className="form-section-title"><Baby size={20} /><span>Hồ sơ đầu tiên của con</span></div>
        <div className="form-grid">
          <label>
            Tên gọi trong nhà
            <input required value={form.childNickname} onChange={(event) => setForm({ ...form, childNickname: event.target.value })} />
          </label>
          <label>
            Năm sinh
            <input type="number" min="1990" max={new Date().getFullYear()} value={form.birthYear} onChange={(event) => setForm({ ...form, birthYear: Number(event.target.value) })} />
          </label>
        </div>

        <div className="form-section-title"><Sparkles size={20} /><span>Khung quà mặc định</span></div>
        <div className="form-grid">
          <label>
            Ngân sách/tháng (đ)
            <input type="number" min="0" step="10000" value={form.monthlyBudgetVnd} onChange={(event) => setForm({ ...form, monthlyBudgetVnd: Number(event.target.value) })} />
          </label>
          <label>
            Giá tối đa/món (đ)
            <input type="number" min="0" step="10000" value={form.maxRewardPriceVnd} onChange={(event) => setForm({ ...form, maxRewardPriceVnd: Number(event.target.value) })} />
          </label>
        </div>
        <button className="button button--primary button--wide" disabled={busy} type="submit">
          {busy ? 'Đang thiết lập…' : 'Tạo gia đình Kidee'}
        </button>
      </form>
    </div>
  );
}
